import React, { createElement } from 'react';
// Module-level side effect: runs BEFORE React mounts.
// Injects preconnect + non-blocking font stylesheet + LCP image preload.
if (typeof document !== 'undefined') {
  const head = document.head;
  const ensureLink = (rel: string, href: string, attrs: Record<string, string> = {}) => {
    if (head.querySelector(`link[rel="${rel}"][href="${href}"]`)) return;
    const link = document.createElement('link');
    link.rel = rel;
    link.href = href;
    Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
    head.appendChild(link);
  };
  // Preconnect so DNS/TLS happens in parallel with HTML parse
  ensureLink('preconnect', 'https://fonts.googleapis.com');
  ensureLink('preconnect', 'https://fonts.gstatic.com', {
    crossorigin: ''
  });
  ensureLink('preconnect', 'https://cdn.magicpatterns.com');
  // Non-blocking Google Fonts stylesheet — loaded as media="print" then swapped
  // to "all" so it never blocks First Contentful Paint.
  if (!head.querySelector('link[data-fonts="google"]')) {
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Bai+Jamjuree:wght@700&display=swap';
    fontLink.media = 'print';
    fontLink.setAttribute('data-fonts', 'google');
    fontLink.onload = function () {
      ;
      (fontLink as HTMLLinkElement).media = 'all';
    };
    head.appendChild(fontLink);
    setTimeout(() => {
      if ((fontLink as HTMLLinkElement).media !== 'all') {
        ;
        (fontLink as HTMLLinkElement).media = 'all';
      }
    }, 3000);
  }
  // Preload the LCP image so it starts downloading immediately, in parallel with CSS/JS.
  if (!head.querySelector('link[rel="preload"][data-lcp="hero"]')) {
    const preload = document.createElement('link');
    preload.rel = 'preload';
    preload.setAttribute('as', 'image');
    preload.setAttribute('fetchpriority', 'high');
    preload.setAttribute('type', 'image/png');
    preload.setAttribute('data-lcp', 'hero');
    preload.href = 'https://cdn.magicpatterns.com/uploads/nCdfyaEEbhWc5s37T69Hk2/mocap_polonia.png';
    head.appendChild(preload);
  }
}
export function PreloadAssets() {
  return null;
}